import { createFileRoute } from "@tanstack/react-router";

import { env } from "@/env/public-env";
import { seo, getCanonicalLinks } from "@/utils/seo";
import { MainLanding } from "@/web/landing/components/main-landing";

export const Route = createFileRoute("/_web/")({
  head: () => ({
    meta: [
      ...seo({
        title:
          "vivus - Automatic K8s, CI/CD & OpenTelemetry Monitoring with AI Triage",
        description:
          "Detect Kubernetes crashes, CI/CD failures, Sentry errors, and OpenTelemetry signals automatically. AI-ready GitHub issues for Claude and Copilot analysis. Free while in beta.",
        keywords:
          "kubernetes monitoring, k8s alerting, azure devops monitoring, ci/cd failure detection, opentelemetry monitoring, otel error tracking, otlp receiver, ai devops, claude code, github copilot, infrastructure monitoring",
        canonical: "https://vivus.cz",
        image: `${env.VITE_BASE_URL}/api/og/page/homepage.png`,
      }),
    ],
    links: [...getCanonicalLinks(env.VITE_BASE_URL)],
  }),
  component: Home,
});

function Home() {
  return <MainLanding />;
}
